export const SALE_POINT_OPTIONS = [  
  { id: 1, name: "I04 - ARTEMIS(GGN)" },  
  { id: 2, name: "PARAS HOSPITAL" },  
  { id: 3, name: "VIPIN VERMA" },  
];  
 
export const APPROVED_BY_OPTIONS = [  
  { id: 1, name: "Mr. Ganesh Singh" },  
  { id: 2, name: "Mr. Kishore Sharma" },  
  { id: 3, name: "Mr. Sunil Sharma" },  
];  
export const APPROVED_BY_OPTIONS_LEVEL_ONE = [
  { id: 2, name: "CFO", userId: "CFO", category: "CFO" },
  { id: 3, name: "CEO", userId: "CEO", category: "CEO" },
  {id:1, name:"Nandita Sharma", userId:"Nandita", category:"MD"},
  {id:4, name:"Kartik Sharma", userId:"Kartik", category:"MD"},
  {id:5, name:"Udit Sharma", userId:"Udit", category:"MD"},
];
 
export const APPROVED_BY_OPTIONS_LEVEL_TWO = [
  { id: 1, name: "Mr. Vipin", userId: "FIMNGR", category: "SALES" },
  { id: 2, name: "PROCUREMENT-MNGR", userId: "PROCMNGR", category: "SALES" },
  { id: 3, name: "Procurement Head", userId: "PROCHEAD", category: "SALES" },
];
 
export const RENT_SLAB_OPTIONS = [
  { id: 1, name: "Per Day", code: "PER_DAY", description: "PER_DAY"},
  { id: 2, name: "7 Days", code: "7_DAYS",description: "7_DAYS" },
  { id: 3, name: "15 Days", code: "15_DAYS",description: "15_DAYS" },
  { id: 4, name: "30 Days", code: "30_DAYS", description: "30_DAYS" },
];
 
export const ORDER_TYPE_OPTIONS = [  
  { id: 1, name: "New" },  
  { id: 2, name: "Running" },  
  { id: 3, name: "Old" },  
  { id: 4, name: "RESPIRATORY PACKAGE" },  
  { id: 5, name: "ICU PACKAGE-BASIC-NURSE" },  
  { id: 6, name: "ICU PACKAGE-MEDIUM-NURSE" },  
  { id: 7, name: "ICU PACKAGE-ADVANCED-NURSE" },  
  { id: 8, name: "ICU PACKAGE-BASIC+NURSE" },  
  { id: 9, name: "ICU PACKAGE-MEDIUM+NURSE" },  
  { id: 10, name: "ICU PACKAGE-ADVANCED+NURSE" },  
];  
 
export const SOURCE_OF_CALL_OPTIONS = [  
  { id: 1, name: "Other" },  
  { id: 2, name: "Just Dial" },  
  { id: 3, name: "Newspaper" },  
  { id: 4, name: "Web" },  
  { id: 5, name: "Doctor" },  
  { id: 6, name: "User Reference" },  
  { id: 7, name: "Direct" },  
];  
 
export const ID_PROOF_OPTIONS = [  
  { id: 1, name: "Adhar Card" },  
  { id: 2, name: "Driving License" },  
  { id: 3, name: "Voter ID" },  
  { id: 4, name: "PAN Card" },  
  { id: 5, name: "Passport" },  
];  
 
// export const DOCTOR_TYPE_OPTIONS = [
//   { id: 1, name: "Hospital" },  
//   { id: 2, name: "Doctor" },      
//   // { id: 3, name: "Listed" },      
//   { id: 4, name: "Non-Listed" },
//   { id: 5, name: "Not Given" },
// ];
export const DOCTOR_TYPE_OPTIONS = [
  { id: 1, name: "Listed" },      
  { id: 2, name: "Non-Listed" },
  { id: 3, name: "Not Given" },
];

export const DOCTOR_TYPE_SELECTION_OPTIONS = [
  { id: 1, name: "Doctor", code:"Doctor" }, 
  { id: 2, name: "Hospital", code:"Hospital" },  
       
];

export const PATIENT_TYPE_OPTIONS = [
  { id: 3, name: "Listed" },      
  { id: 4, name: "Non-Listed" },
];
 
export const HOSPITAL_OPTIONS = [  
  { id: 1, name: "AAKASH" },  
  { id: 2, name: "ARTEMIS" },  
  { id: 3, name: "AYUSHMAN" },  
  { id: 4, name: "MANIPAL" },  
  { id: 5, name: "PARAS" },  
  { id: 6, name: "VENKATESHWAR" },  
];  

export const GENDER_OPTIONS = [
  { id: 1, name: "Male" },
  { id: 2, name: "Female" },
  { id: 3, name: "Other" },
];
 
export const STATE_OPTIONS = [  
  "Jammu & Kashmir",  
  "Himachal Pradesh",  
  "Punjab",  
  "Chandigarh",  
  "Uttarakhand",  
  "Haryana",  
  "East Delhi",  
  "Rajasthan",  
  "Uttar Pradesh",  
  "Bihar",  
  "Sikkim",  
  "Arunachal Pradesh",  
  "Nagaland",  
  "Manipur",  
  "Mizoram",  
  "Tripura",  
  "Meghalaya",  
  "Assam",  
  "West Bengal",  
  "Jharkhand",  
  "Orissa",  
  "Chhattisgarh",  
  "Madhya Pradesh",  
  "Gujarat",  
  "Daman & Diu",  
  "Dadra & Nagar Haveli",  
  "Maharashtra",  
  "Andhra Pradesh",  
  "Karnataka",  
  "Goa",  
  "Lakshadweep",  
  "Kerala",  
  "Tamil Nadu",  
  "Puducherry",  
  "Andaman & Nicobar Islands",  
  "Telengana",  
  "Andrapradesh(New)",  
  "West Delhi",  
  "North Delhi",  
  "South Delhi",  
  "Central Delhi",  
].map((s, i) => ({ id: i + 1, name: s }));  
 
export const IS_DIABETIC_OPTIONS = [  
  { id: 1, name: "Yes" },  
  { id: 2, name: "No" },  
];  
 
export const MOCK_DOCTORS = [  
  { name: "Dr. A. Kumar", hospital: "AAKASH", code: "DR001" },  
  { name: "Dr. B. Singh", hospital: "AAKASH", code: "DR002" },  
  { name: "Dr. C. Sharma", hospital: "ARTEMIS", code: "DR003" },  
  { name: "Dr. D. Verma", hospital: "PARAS", code: "DR004" },  
];  

export const serviceAssignentCategoryOption = [  
  { id: 1, name: "Dispatch", description: "Dispatch", code: "Dispatch" },  
  { id: 2, name: "Replacement", description: "Replacement", code: "Replacement" },  
  { id: 3 ,name: "Service", description: "Service", code: "Service" },  
  { id:  4,name: "Collect Money", description: "Collect Money", code: "Collect Money" },  
  { id: 5 ,name: "Receive Product", description: "Receive Product", code: "Receive Product" },  
  // { id: 5 ,name: "Online Payment", description: "Online Payment", code: "Online Payment" },  
]; 


export const serviceAssignentCategoryOptionForExtension = [  
  { id: 1, name: "Dispatch", description: "Dispatch", code: "Dispatch" },  
  { id: 2, name: "Replacement", description: "Replacement", code: "Replacement" },  
  { id: 3 ,name: "Service", description: "Service", code: "Service" },  
  { id:  4,name: "Collect Money", description: "Collect Money", code: "Collect Money" },  
  // { id: 5 ,name: "Receive Product", description: "Receive Product", code: "Receive Product" },  
  // { id: 5 ,name: "Online Payment", description: "Online Payment", code: "Online Payment" },  
]; 

export const COST_POINT_OPTIONS = [  
  { id: 1, name: "PCD1" },  
  { id: 2, name: "PCD2" }, 
  { id: 3, name: "RAJU" }, 
  { id: 4, name: "BHAWANDER" }, 
  { id: 5, name: "MANOJ MATHUR" }, 
  { id: 6, name: "KISHORE SHARMA" }, 
];

export const CANCELLABLE_ERF_STATUS_CODES = ["ATS", "RTD", "USE"]; 
